import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './hamburgermenu.css';

const HamburgerMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [accessibleFeatures, setAccessibleFeatures] = useState([]);
  const location = useLocation();

  useEffect(() => {
    // Load accessible features from localStorage
    loadAccessibleFeatures();
  }, []);

  const loadAccessibleFeatures = () => {
    try {
      const userData = localStorage.getItem('userData');
      if (userData) {
        const parsedData = JSON.parse(userData);
        const student = parsedData.student;
        
        if (student?.accessible_subjects) {
          // Get all unique features the student has access to
          const features = new Set();
          
          student.accessible_subjects.forEach(subject => {
            if (subject.features && Array.isArray(subject.features)) {
              subject.features.forEach(feature => {
                features.add(feature);
              });
            }
          });
          
          setAccessibleFeatures(Array.from(features));
          
        }
      }
    } catch (error) {
      console.error('Error loading accessible features:', error);
      setAccessibleFeatures([]);
    }
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  // Helper function to check if user has access to a specific feature
  const hasFeatureAccess = (featureName) => {
    return accessibleFeatures.includes(featureName);
  };

  return (
    <>
      {/* Hamburger Menu Button */}
      <button 
        className={`hamburger-menu-btn ${isOpen ? 'open' : ''}`}
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <div className="hamburger-line"></div>
        <div className="hamburger-line"></div>
        <div className="hamburger-line"></div>
      </button>

      {/* Overlay */}
      <div 
        className={`side-menu-overlay ${isOpen ? 'open' : ''}`}
        onClick={closeMenu}
      ></div>

      {/* Side Menu */}
      <div className={`side-menu ${isOpen ? 'open' : ''}`}>
        {/* Menu Header */}
        <div className="menu-header">
          <h3 className="menu-title">Navigation</h3>
        </div>

        {/* Menu Navigation */}
        <nav className="menu-nav">
          {/* Always show Home/Dashboard */}
          <Link 
            to="/dashboard"
            className={`menu-nav-item ${isActive('/dashboard') ? 'active' : ''}`}
            onClick={closeMenu}
          >
            🏠 Home
          </Link>
          
          {/* Only show Teaching Mode if user has access */}
          {hasFeatureAccess('teaching_mode') && (
            <Link 
              to="/teaching" 
              className={`menu-nav-item ${isActive('/teaching') ? 'active' : ''}`}
              onClick={closeMenu}
            >
              📚 Teaching Mode
            </Link>
          )}
          
          {/* Only show Doubt Resolution if user has access */}
          {hasFeatureAccess('doubt_resolution') && (
            <Link 
              to="/doubt-solving" 
              className={`menu-nav-item ${isActive('/doubt-solving') ? 'active' : ''}`}
              onClick={closeMenu}
            >
              ❓ Ask Doubts
            </Link>
          )}
          
          {/* Only show Quiz if user has access */}
          {hasFeatureAccess('quiz') && (
            <Link 
              to="/quiz" 
              className={`menu-nav-item ${isActive('/quiz') ? 'active' : ''}`}
              onClick={closeMenu}
            >
              🧠 Quiz Mode
            </Link>
          )}

          {/* Only show Enhanced Learning if user has access */}
          {hasFeatureAccess('enhanced_learning') && (
            <Link 
              to="/enhanced-chunks" 
              className={`menu-nav-item ${isActive('/enhanced-chunks') ? 'active' : ''}`}
              onClick={closeMenu}
            >
              ⚡ Enhanced Learning
            </Link>
          )}

          {/* Show message if no features are accessible */}
          {accessibleFeatures.length === 0 && (
            <div className="menu-nav-item disabled">
              <span style={{ color: '#999', fontStyle: 'italic' }}>
                No features accessible. Contact administrator.
              </span>
            </div>
          )}
        </nav>

        {/* Menu Footer - Branding */}
        <div className="menu-footer">
          <p className="menu-branding">Edunol</p>
        </div>
      </div>
    </>
  );
};

export default HamburgerMenu;